import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = ["src"];
import { computed, onMounted, ref, watch } from "vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'DocumentThumb',
    props: {
        docKey: {},
        kind: {},
        url: {},
        size: {},
        width: {},
        getProxy: { type: Function }
    },
    setup(__props) {
        const props = __props;
        const canvasEl = ref(null);
        const height = computed(() => props.size ? Math.round((props.width * props.size.height) / props.size.width) : props.width * 1.3);
        async function draw() {
            const proxy = props.getProxy(props.docKey);
            if (props.kind !== "pdf" || !proxy || !canvasEl.value || !props.size)
                return;
            const page = await proxy.getPage(1);
            const ratio = Math.min(window.devicePixelRatio || 1, 2);
            const viewport = page.getViewport({ scale: (props.width / props.size.width) * ratio });
            const canvas = canvasEl.value;
            canvas.width = Math.floor(viewport.width);
            canvas.height = Math.floor(viewport.height);
            const context = canvas.getContext("2d");
            if (context)
                await page.render({ canvasContext: context, viewport }).promise.catch(() => undefined);
        }
        onMounted(draw);
        watch(() => props.size, draw);
        return (_ctx, _cache) => {
            const _component_v_icon = _resolveComponent("v-icon");
            return (_openBlock(), _createElementBlock("div", {
                class: "doc-thumb",
                style: _normalizeStyle({ width: `${__props.width}px`, height: `${height.value}px` })
            }, [
                (__props.kind === 'image')
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: __props.url,
                        alt: "",
                        draggable: "false"
                    }, null, 8, _hoisted_1))
                    : (__props.kind === 'file')
                        ? (_openBlock(), _createBlock(_component_v_icon, {
                            key: 1,
                            size: "18",
                            class: "doc-thumb__file"
                        }, {
                            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                                    _createTextVNode("mdi-file-outline", -1)
                                ]))]),
                            _: 1
                        }))
                        : (_openBlock(), _createElementBlock("canvas", {
                            key: 2,
                            ref_key: "canvasEl",
                            ref: canvasEl
                        }, null, 512))
            ], 4));
        };
    }
});
